import { useLocation } from "react-router-dom";

function useFindPath() {
  const location = useLocation();
  const currentPath = location.pathname;
  return { currentPath };
}
export default useFindPath;
